var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "governance-warning",
          class: `governance-warning--${_vm.severity}`,
          attrs: { role: "status" },
        },
        [
          _c(
            "v-icon",
            {
              staticClass: "mr-2",
              attrs: {
                color: _vm.severity === "block" ? "#7f1d1d" : "#92400e",
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.severity === "block" ? "mdi-lock" : "mdi-alert-octagon"
                  ) +
                  " "
              ),
            ]
          ),
          _c("div", { staticClass: "governance-warning__body" }, [
            _c("span", { staticClass: "governance-warning__title" }, [
              _c("strong", [_vm._v(_vm._s(_vm.bannerTitle))]),
              _c("span", { staticClass: "governance-warning__subtitle" }, [
                _vm._v(" · " + _vm._s(_vm.bannerSubtitle) + " "),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "governance-warning__rooms" },
              [
                _vm._l(_vm.displayedRooms, function (room) {
                  return _c(
                    "v-chip",
                    {
                      key: room.id,
                      staticClass: "mr-1 governance-warning__chip",
                      attrs: {
                        small: "",
                        label: "",
                        color: _vm.severity === "block" ? "#fecaca" : "#fde68a",
                        "text-color":
                          _vm.severity === "block" ? "#7f1d1d" : "#78350f",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.goToRoom(room)
                        },
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-lock-outline"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.shortName(room)) + " "),
                      room.percent
                        ? _c("span", { staticClass: "ml-1" }, [
                            _vm._v(
                              "(" + _vm._s(Math.round(room.percent)) + "%)"
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                _vm.hiddenCount > 0
                  ? _c("span", { staticClass: "text-caption ml-1" }, [
                      _vm._v(" +" + _vm._s(_vm.hiddenCount) + " "),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ]),
          !_vm.isOnVacancyControl || _vm.severity === "warning"
            ? _c(
                "v-btn",
                {
                  staticClass: "ml-2",
                  attrs: {
                    small: "",
                    outlined: "",
                    color: _vm.severity === "block" ? "#7f1d1d" : "#92400e",
                  },
                  on: { click: _vm.goToVacancyControl },
                },
                [
                  _c("v-icon", { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-arrow-right"),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isOnVacancyControl
                          ? "Ir ao topo"
                          : "Ver Gestão de Vagas"
                      ) +
                      " "
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }